import { observer } from "mobx-react";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { Routes as AppRoutes } from "../../../Navigation/Routes";
import FocusedConversation from "./FocusedConversation/FocusedConversation";
import UnfocusedConversationWrapper from "./UnfocusedConversation/UnfocusedConversationWrapper";
import { useStore } from "utils/useStore";
import ConversationsStore, {
    loadConversations,
} from "components/Conversations/Stores/ConversationsStore";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";

const ConversationRouting: React.FunctionComponent = observer(() => {
    const store = useStore(ConversationsStore);
    return (
        <Routes>
            {store.authStore.canUserView("Workflows") && (
                <Route
                    path={":id/workflow"}
                    element={<FocusedConversation currentRoute="workflow" />}
                />
            )}
            {store.authStore.canUserView("Agent Coaching") && (
                <Route
                    path={`:id/${AppRoutes.EVAL_COACHING}`}
                    element={
                        <FocusedConversation
                            currentRoute={AppRoutes.EVAL_COACHING}
                        />
                    }
                />
            )}

            <Route
                path={":id"}
                element={<FocusedConversation currentRoute="" />}
            />
            <Route
                path={``}
                element={
                    store.getTaskLoading(loadConversations) ? (
                        <AcxEmptyState size="large" variant="loading" />
                    ) : (
                        <UnfocusedConversationWrapper />
                    )
                }
            />
        </Routes>
    );
});

export default ConversationRouting;
